import React from 'react';

// Icons
import menuInfo from "../../assets/images/menu_info.svg";

// CSS Files
import './BulletHeader.css';

const BulletHeader = (props) => {
   return (
       <h2 className={"pt-3 pb-2"}>
          {props.text}
          {props.showInfoButton &&
              <img className="info-button ml-1" src={menuInfo} onClick={props.infoButtonOnClick} alt={"info button"}/>
          }
       </h2>
   )
}

export default BulletHeader;